import { useEffect, useMemo, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { motion } from 'framer-motion'

import { navbarLinks } from '../../data/navbarLinks.js'
import logoImg from '../../assets/Logo.jpg'

export default function SiteNavbar() {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  const items = useMemo(() => navbarLinks, [])


  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    if (!open) return
    document.body.classList.add('mobile-menu-open')
    return () => document.body.classList.remove('mobile-menu-open')
  }, [open])

  const linkClass = ({ isActive }) =>
    `px-3 py-2 rounded-md text-sm font-medium transition-colors ${
      isActive ? 'text-brand-accent bg-brand-primary/10' : 'text-slate-700 hover:text-brand-primary'
    }`

  return (
    <header className={`sticky top-0 z-50 ${scrolled ? 'backdrop-blur bg-white/80 shadow-sm' : 'bg-white/90'}`}>
      <div className="mx-auto max-w-7xl px-4">
        <div className="h-16 flex items-center justify-between">
          <NavLink to="/" className="flex items-center">
            <div className="w-[200px] h-[100px] overflow-hidden flex items-center justify-center">
              <img src={logoImg} alt="Ritik Medicare" className="w-full h-full object-contain" />
            </div>
          </NavLink>


          <nav className="hidden lg:flex items-center gap-1">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} className={linkClass}>
                {it.label}
              </NavLink>
            ))}
          </nav>

          <button
            aria-label="Open menu"
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-xl border border-slate-200 text-slate-700"
            onClick={() => setOpen(true)}
          >
            <Menu size={20} />
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <motion.div
        initial={false}
        animate={{ opacity: open ? 1 : 0, pointerEvents: open ? 'auto' : 'none' }}
        className="lg:hidden fixed inset-0 z-[60] bg-black/30"
        onClick={() => setOpen(false)}
      />
      <motion.div
        initial={false}
        animate={{ x: open ? 0 : '100%' }}
        transition={{ type: 'tween', duration: 0.25 }}
        className="lg:hidden fixed top-0 right-0 z-[70] h-full w-[85%] max-w-xs bg-white shadow-2xl border-l"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-16 flex items-center justify-between px-4 border-b">
          <div className="font-bold text-slate-900">Menu</div>
          <button
            aria-label="Close menu"
            className="w-10 h-10 rounded-xl border border-slate-200 text-slate-700 flex items-center justify-center"
            onClick={() => setOpen(false)}
          >
            <X size={20} />
          </button>
        </div>

        <div className="p-4">
          <div className="flex flex-col gap-1">
            {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-xl text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-brand-primary/10 text-brand-primary'
                      : 'text-slate-700 hover:bg-slate-50'
                  }`
                }
              >
                {it.label}
              </NavLink>
            ))}
          </div>

          <div className="mt-6 rounded-2xl border border-slate-200 p-4">
            <div className="text-sm font-semibold text-slate-900">Need a quote?</div>
            <div className="text-sm text-slate-600 mt-1">
              Send enquiry and we’ll get back quickly.
            </div>
            <NavLink
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex w-full items-center justify-center bg-brand-primary text-white px-4 py-2 rounded-xl text-sm font-semibold hover:brightness-110 transition"
            >
              Contact Us
            </NavLink>
          </div>
        </div>
      </motion.div>
    </header>
  )
}

